import {DodgerBlueColor, whiteColor} from '../../cmsMainStyle'


const normalDialogStyle = theme => ({
	dialogRoot: {
		height: theme.spacing(150)
		// height: theme.spacing("var(--dialog-height)")
		// height: "var(--dialog-height)"
	},

	headerFooter: {
		backgroundColor: DodgerBlueColor[11],
		color: whiteColor,
		paddingLeft: theme.spacing(3),
		paddingRight: theme.spacing(3)
	},

	searchBtn: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2)
	},
})

const dialogTitleStyles = (theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},

	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: whiteColor
	},
})


export {normalDialogStyle, dialogTitleStyles}